// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Xitd","select":"styles_select__21aES"};